import styled from 'styled-components';
export var Inner = styled.div.withConfig({
  displayName: "partials__Inner",
  componentId: "sc-iy80ix-0"
})(["display:block;ul{li{margin-bottom:16px;list-style:none;}}"]);